import { CheckIcon } from './Icons.jsx';
import CorrectnessTally from './CorrectnessTally.jsx';
import './MatchQuestion.css';

/**
 * Teacher/projector view for a match question — shows the same diagram and
 * label pool students see (static, nothing draggable) as a shared reference
 * while everyone matches on their own device. On reveal, shows the labels
 * already placed in their correct slots, plus the reveal note and tally.
 */
export default function HostMatchPreview({ payload, revealed, tally }) {
  if (revealed) {
    const correctMapping = payload.correctMapping || {};
    return (
      <div className="stack host-match-preview-stack">
        <div className="match-diagram host-match-diagram">
          {payload.slots.map((slot, i) => {
            const label = payload.labels.find((l) => l.id === correctMapping[slot.id]);
            return (
              <div key={slot.id} className="match-slot-wrap">
                <div className="match-slot is-correct host-match-slot">
                  {label ? label.text : slot.caption}
                </div>
                {i < payload.connectors.length && (
                  <div className="match-connector host-match-connector">→ {payload.connectors[i]} →</div>
                )}
              </div>
            );
          })}
        </div>

        {payload.revealNote && (
          <p className="match-success text-center row" style={{ justifyContent: 'center', gap: '6px' }}>
            <CheckIcon size={18} />
            <span>{payload.revealNote}</span>
          </p>
        )}

        <CorrectnessTally tally={tally} />
      </div>
    );
  }

  return (
    <div className="stack host-match-preview-stack">
      <div className="match-diagram host-match-diagram">
        {payload.slots.map((slot, i) => (
          <div key={slot.id} className="match-slot-wrap">
            <div className="match-slot host-match-slot">{slot.caption}</div>
            {i < payload.connectors.length && (
              <div className="match-connector host-match-connector">→ {payload.connectors[i]} →</div>
            )}
          </div>
        ))}
      </div>

      <div className="match-pool host-match-pool">
        {payload.labels.map((label) => (
          <span key={label.id} className="match-chip host-match-chip">
            {label.text}
          </span>
        ))}
      </div>
    </div>
  );
}
